import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useAuth } from '../contexts/AuthContext';

const QUICK_USERS = [
  { nm:'أحمد القحطاني', role:'رئيس الاتحاد',    ini:'أح', bg:'#C9952A', email:'ahmed@sportix.ae' },
  { nm:'محمد العتيبي',  role:'المدير الفني',     ini:'مع', bg:'#1A3D7A', email:'mohammed@sportix.ae' },
  { nm:'فاطمة الزهراء', role:'مدير السكرتارية', ini:'فز', bg:'#B0271E', email:'fatima@sportix.ae' },
  { nm:'نواف العمري',   role:'المدير المالي',    ini:'نو', bg:'#1A7A4A', email:'nawaf@sportix.ae' },
];

export default function LoginPage() {
  const [email, setEmail]       = useState('ahmed@sportix.ae');
  const [password, setPassword] = useState('Admin@1234');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);
  const { login }  = useAuth();
  const navigate   = useNavigate();

  const doLogin = async (e) => {
    e?.preventDefault();
    setError(''); setLoading(true);
    try {
      await login(email, password);
      toast.success('مرحباً بك في SPORTIX-MATRIX');
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.message || 'بيانات الدخول غير صحيحة');
    } finally { setLoading(false); }
  };

  const quickLogin = async (u) => {
    setError(''); setLoading(true);
    try {
      await login(u.email, 'Admin@1234');
      toast.success(`مرحباً ${u.nm}`);
      navigate('/');
    } catch {
      setError('حدث خطأ، تأكد من تشغيل الخادم');
    } finally { setLoading(false); }
  };

  return (
    <div className="login-screen">
      <div className="login-box">
        <div className="login-logo">⚽</div>
        <div className="login-title">SPORTIX – MATRIX</div>
        <div className="login-sub">منصة الإدارة الرياضية الذكية · sportix.ae</div>

        {error && <div className="error-msg">{error}</div>}

        <form onSubmit={doLogin} style={{marginBottom:16}}>
          <div className="form-group">
            <label className="login-label">البريد الإلكتروني</label>
            <input className="login-input" type="email" value={email}
              onChange={e=>setEmail(e.target.value)} placeholder="name@sportix.ae" required />
          </div>
          <div className="form-group" style={{marginBottom:12}}>
            <label className="login-label">كلمة المرور</label>
            <input className="login-input" type="password" value={password}
              onChange={e=>setPassword(e.target.value)} placeholder="••••••••" required />
          </div>
          <button type="submit" className="login-btn" disabled={loading}>
            {loading ? '⏳ جارٍ الدخول...' : '🔐 دخول إلى المنصة'}
          </button>
        </form>

        <div style={{fontSize:9,color:'rgba(255,255,255,.3)',textAlign:'center',marginBottom:8}}>— أو اختر مستخدماً سريعاً —</div>
        <div style={{display:'flex',flexDirection:'column',gap:6}}>
          {QUICK_USERS.map(u => (
            <div key={u.email} className="login-quick" onClick={() => quickLogin(u)}>
              <div className="avatar" style={{width:26,height:26,fontSize:9,background:u.bg,color:'#fff',flexShrink:0}}>{u.ini}</div>
              <div>
                <div style={{fontSize:10,fontWeight:700,color:'rgba(255,255,255,.85)'}}>{u.nm}</div>
                <div style={{fontSize:9,color:'rgba(255,255,255,.4)'}}>{u.role} · sportix.ae</div>
              </div>
            </div>
          ))}
        </div>
        <div style={{marginTop:14,fontSize:8.5,color:'rgba(255,255,255,.25)'}}>
          كلمة المرور الافتراضية: Admin@1234 · SPORTIX-MATRIX v4
        </div>
      </div>
    </div>
  );
}
